import moment from 'moment';

export const formatAlgoStatus = (
  algoStatus: any = []
): Record<string, string> => {
  if (!Array.isArray(algoStatus)) return {} as Record<string, string>;

  return algoStatus.reduce(
    (acc: Record<string, string>, obj: Record<string, string>) => {
      return { ...acc, ...obj };
    },
    {}
  );
};

/** Key the video-wake model reports its status under in a test's algoStatus. */
export const VIDEO_WAKE_ALGO_ID = 'video_wake';

// On in-lab tests with video, algo 1 also runs the video-wake model. Algo 1
// only counts as finished once both have reported back. Takes the flattened
// status from formatAlgoStatus.
export const isAlgo1Running = (
  algoStatus: Record<string, string | null> | undefined
): boolean =>
  algoStatus?.['1'] === 'Processing' ||
  algoStatus?.[VIDEO_WAKE_ALGO_ID] === 'Processing';


export const  calculateAge = (birthDate) => {
  if (birthDate) {
    // A date of birth is a calendar date, so age is counted in whole years
    // against the viewer's own calendar. A value carrying a time zone is cut
    // back to its date part first: read as an instant, a birth date stored at
    // midnight UTC lands on the previous day for viewers behind UTC and moves
    // the birthday a day either side of where it belongs.
    const calendarDate =
      typeof birthDate === 'string' ? birthDate.split('T')[0] : birthDate;
    return moment().diff(moment(calendarDate), 'years');
  } else {
    return 0;
  }
};


/**
 * Returns a scheduled datetime:
 * - Base everything on the provided date
 * - If current time is before 8:00 PM → today at 8:00 PM
 * - Otherwise → 30 minutes from now (rounded to the next 30-minute mark)
 */
export function getNextScheduleDateTime(date?: string): string {
  const now = moment();
  let schedule: moment.Moment;

  if (date) {
    // Base = date + 1 day at 9:00 AM
    schedule = moment(date)
      .add(1, 'day')
      .set({
        hour: 9,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

    // If still somehow in the past, move forward in 30-min steps
    if (schedule.isBefore(now)) {
      schedule = now.clone().add(30, 'minutes');
    }
  } else {
    // Existing behavior (today-based)
    const todayAt8PM = moment().set({
      hour: 20,
      minute: 0,
      second: 0,
      millisecond: 0,
    });

    schedule = todayAt8PM.isBefore(now)
      ? now.clone().add(30, 'minutes')
      : todayAt8PM;
  }

  // Round UP to next 30-minute mark
  const minutes = schedule.minutes();
  const roundedMinutes = minutes < 30 ? 30 : 0;

  if (roundedMinutes === 0) {
    schedule = schedule
      .add(1, 'hour')
      .set({ minute: 0, second: 0, millisecond: 0 });
  } else {
    schedule = schedule.set({ minute: 30, second: 0, millisecond: 0 });
  }

  return schedule.toISOString();
}



  export const isInvalidValue = (value: string): boolean =>  {
    return value === '999';
  }

  export const sanitizeAlgoValue = (value: any): any =>{
    return isInvalidValue(value) ? null : value;
  }
